import styled, { css } from 'styled-components';

export const Container = styled.div<{ isError?: boolean, top?: number, left?: number }>`
  display: flex;
  align-items: center;
  gap: var(--spacement-default);
  padding: var(--spacement-default) var(--spacement-medium);
  background-color: #ffffff;
  margin-left: calc(var(--spacement-xxlarge) * 1.8);
  width: fit-content;

  border-radius: var(--radius-small);
  border: 1px solid var(--neutral-2);
  border-bottom: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  ${props => props.top && css`
    top: ${props.top}px;
  `}

  ${props => props.left && css`
    left: ${props.left}px;
  `}

  ${props => props.isError && css`
    background-color: #FFFCDF;
    border-color: #FFDD6D;
  `}

  @media screen and (max-width: 768px) {
    margin-left: var(--spacement-medium);
  }

  @media screen and (max-width: 500px) {
    & svg {
      width: 24px;
      height: 24px;
    }
  }
`
